import React from 'react';
import { getChangeColorClass } from '../utils/formatters';

const PERIODS = {
  '1h': { code: 'H', description: '1 hour' },
  '24h': { code: 'D', description: '24 hours' },
  '1d': { code: 'D', description: '1 day (versus previous close)' },
  '7d': { code: 'W', description: '7 days' },
  '30d': { code: 'M', description: '30 days' },
  '1y': { code: 'Y', description: '1 year' },
};

const TokenPriceChanges = ({ marketData, items: customItems }) => {
  const md = marketData || {};
  const items = customItems || [
    { label: '1h', value: md.priceChange1h },
    { label: '24h', value: md.priceChange24h },
    { label: '7d', value: md.priceChange7d },
    { label: '30d', value: md.priceChange30d },
    { label: '1y', value: md.priceChange1y },
  ];

  return (
    <dl aria-label="Price changes" className="flex min-w-0 max-w-full flex-wrap items-center gap-y-1 text-xs sm:text-sm">
      {items.map((item, index) => {
        const period = PERIODS[item.label] || { code: item.label, description: item.label };
        const value = item.value == null ? '—' : String(item.value).replace(/^\+/, '');
        return (
          <div key={item.label} title={period.description} className={`inline-flex shrink-0 items-baseline gap-1.5 whitespace-nowrap py-0.5 ${index === 0 ? 'pr-2' : 'border-l border-gray-300 px-2 dark:border-gray-600'}`}>
            <dt title={period.description} aria-label={period.description} className="text-[10px] font-medium text-gray-500 dark:text-gray-400 sm:text-xs">{period.code}</dt>
            <dd aria-label={item.value == null ? undefined : String(item.value)} className={`font-semibold tabular-nums ${item.value == null ? 'text-gray-500 dark:text-gray-400' : getChangeColorClass(item.value)}`}>{value}</dd>
          </div>
        );
      })}
    </dl>
  );
};

export default TokenPriceChanges;
